import {
    BlockKey,
    IndicatorConfig,
    IndicatorFormat,
    IndicatorKey,
    IndicatorStyle,
    InspectionTab,
    ItemExitMode,
    LogoSource,
    PolygonEditingMode,
    PolygonTool,
    RouteKey,
    TenantConfig,
    TenantId
} from '../types';
import { createZurichApi } from './api/ZurichApi';

/** Indicadores del item: página de item y cabecera de la lista de siniestros del item. */
const ITEM_INDICATORS: IndicatorConfig[] = [
    { key: IndicatorKey.CropType, label: 'Tipo de cultivo' },
    { key: IndicatorKey.DeclaredArea, label: 'Área declarada', format: IndicatorFormat.Hectares },
    { key: IndicatorKey.Department, label: 'Departamento' },
    { key: IndicatorKey.Province, label: 'Provincia' },
    { key: IndicatorKey.Season, label: 'Campaña' }
];

/**
 * Perfil del tenant Zurich: acceso por token en la URL (sin login), página de item y lista de siniestros del item
 * en acordeón. Valores tomados del repo `zurich_gestion_poligonos` (master @ 4f09852).
 */
export const zurichConfig: TenantConfig = {
    id: TenantId.Zurich,
    branding: {
        title: 'Sistema de Gestión de Polígonos',
        titleBold: false,
        documentTitle: 'Gestión de Polígonos',
        logo: { source: LogoSource.Static, staticAsset: require('./assets/logo.png') },
        colors: {
            // `plugins/vuetify.ts` y `$skyblue-color` (`styles/_colors.scss`) del repo de Zurich
            primary: '#3C4A66',
            info: '#2196F3',
            brandBackground: '#2196f3'
        },
        indicatorStyle: IndicatorStyle.Fluid,
        floatingComboboxLabels: false
    },
    api: createZurichApi,
    routes: [RouteKey.Item, RouteKey.ItemClaims],
    features: {
        editPolygonInClaim: false,
        splitPolygon: false,
        samplingReport: true,
        eventDateLine: false,
        satelliteMapByDefault: true,
        noteAuthor: false
    },
    map: {
        polygonEditing: PolygonEditingMode.ContextMenu,
        fitBoundsPadding: false
    },
    analysis: {
        zonificationScales: [3, 4, 5, 6, 7, 8, 9, 10],
        ndviDiffScales: [3, 4, 5, 6, 7, 8, 9, 10]
    },
    pages: {
        item: {
            indicators: ITEM_INDICATORS,
            polygonTools: [
                PolygonTool.PreloadedItems,
                PolygonTool.PointSearch,
                PolygonTool.Draw,
                PolygonTool.Coordinates,
                PolygonTool.UploadFile
            ],
            mergeLoadedPolygons: true,
            showCentroid: true,
            exitMode: ItemExitMode.RedirectFromSaveResponse,
            blocks: [BlockKey.Indicators, BlockKey.PolygonTools, BlockKey.Map, BlockKey.SaveButton]
        },
        itemClaims: {
            indicators: ITEM_INDICATORS
        },
        claimDetail: {
            indicators: [
                { key: IndicatorKey.CreationDate, label: 'Fecha denuncia', format: IndicatorFormat.Date },
                { key: IndicatorKey.ClaimId, label: 'Nº denuncia' },
                { key: IndicatorKey.EventType, label: 'Tipo evento' },
                { key: IndicatorKey.EventDate, label: 'Fecha evento', format: IndicatorFormat.Date }
            ],
            blocks: [
                BlockKey.Indicators,
                BlockKey.MapLayers,
                BlockKey.SurfaceSummary,
                BlockKey.Inspection,
                BlockKey.ClimateChart
            ],
            inspectionTabs: [InspectionTab.Appraisers, InspectionTab.Notes, InspectionTab.SamplingReport]
        }
    }
};
